export default __webpack_public_path__ + "media/images/mini-tripadvisor-f0a9d8b1563c73aa71b9c8a7cc01ad88.svg";